import {Divider, Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Paragraph} = Typography;
const Content = Layout;

const TimelineP = () => {
  return (
    <Layout style={{margin: '0 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className='Title2' style={{color: appColors['ColorNa']}}>Overview</Paragraph>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX']}}>Timeline</Paragraph>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '80%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-1.png'/>
          <p>Img 1. Planning and development journey of the iMoAge project </p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default TimelineP;
